<template>
	<b-card no-body class="p-3">
		<el-timeline>
			<el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon" :type="activity.type"
			:color="activity.color" :size="activity.size" :timestamp="activity.timestamp">
			{{ activity.content }} <span class="text-primary" v-if="activity.content == 'Commitment'">View Details <b-icon
				icon="chevron-right"></b-icon></span>
			</el-timeline-item>
		</el-timeline>
	</b-card>
</template>
<script>
import { Timeline, TimelineItem } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';
import * as moment from 'moment';

export default {
	components: {
	[Timeline.name]: Timeline,
	[TimelineItem.name]: TimelineItem,
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer']),
		...mapState(useCreditReportStore, ['activeCreditReport']),
		activities() {
			let completeProfiles = !_gHlp.isEmpty(_gHlp.getValue(this.activeCustomer,'name',null)) && !_gHlp.isEmpty(_gHlp.getValue(this.activeCustomer,'nric',null)) && !_gHlp.isEmpty(_gHlp.getValue(this.activeCustomer,'dob',null)) && !_gHlp.isEmpty(_gHlp.getValue(this.activeCustomer,'contact_no',null)) && !_gHlp.isEmpty(_gHlp.getValue(this.activeCustomer,'email',null))
			let completeIncome = (_gHlp.getValue(this.activeCustomer,'incomes.main.net_income',0) > 0) && _gHlp.getValue(this.activeCustomer,'checklist.has_net_income',false)
			let completeCommitment = !_gHlp.isEmpty(this.activeCreditReport)
			let completeLoanEC = completeProfiles + completeIncome + completeCommitment

      return [
				{
					content: 'Profile',
					timestamp: 'Profile information has been filled out.',
					size: 'large',
					color: completeProfiles ? '#0bc196' : '',
					icon: completeProfiles ? 'el-icon-check' : '',
				},
				{
					content: 'Net Income',
					timestamp: 'Net income has been filled out.',
					size: 'large',
					color: completeIncome ? '#0bc196' : '',
					icon: completeIncome ? 'el-icon-check' : '',
				},
				{
					content: 'Commitment',
					timestamp: completeCommitment ? 'Latest CTOS report has been generated on ' + moment(this.activeCreditReport.credit_report_response_datetime).format('D MMM, YYYY h:mm A') : '',
					color: completeCommitment ? '#0bc196' : '',
					icon: completeCommitment ? 'el-icon-check' : '',
					size: 'large',
				},
				{
					content: 'Loan Eligibility Calculator',
					timestamp: 'Only can be unlocked once Net Income & Commitment are added.',
					color: completeLoanEC ? '#0bc196' : '',
					icon: completeLoanEC ? 'el-icon-check' : '',
					size: 'large',
				},
			]
		}
	},
}
</script>